import React from "react";

export default function ReasonSelect({
  choices,
  value,
  onChange,
  disabled = false,
  placeholder = "Wybierz uzasadnienie",
  disabledLabel = "Najpierw poprawnie wykonaj poprzedni krok",
  ariaLabel = "Wybór uzasadnienia",
}) {
  const menuRef = React.useRef(null);
  const selected = choices.find((choice) => choice.value === value);
  const label = disabled ? disabledLabel : selected?.label || placeholder;

  if (disabled) {
    return (
      <div
        role="button"
        aria-disabled="true"
        className="input-secondary"
        style={{
          width: "min(100%, 760px)",
          minHeight: 48,
          padding: "10px 14px",
          display: "flex",
          alignItems: "center",
          opacity: 0.58,
          whiteSpace: "normal",
          overflowWrap: "anywhere",
        }}
      >
        {label}
      </div>
    );
  }

  return (
    <details ref={menuRef} style={{ position: "relative", width: "min(100%, 760px)" }}>
      <summary
        className="input-secondary"
        style={{
          minHeight: 48,
          padding: "10px 42px 10px 14px",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          listStyle: "none",
          whiteSpace: "normal",
          overflowWrap: "anywhere",
          lineHeight: 1.35,
        }}
      >
        <span style={{ flex: 1 }}>{label}</span>
        <span aria-hidden="true" style={{ position: "absolute", right: 14 }}>{"\u25be"}</span>
      </summary>
      <div
        role="listbox"
        aria-label={ariaLabel}
        style={{
          position: "absolute",
          zIndex: 20,
          top: "calc(100% + 4px)",
          left: 0,
          width: "100%",
          display: "grid",
          padding: 6,
          border: "1px solid color-mix(in srgb, var(--color-text) 32%, transparent)",
          borderRadius: 8,
          background: "var(--color-surface, #0b0b16)",
          boxShadow: "0 12px 28px rgba(0, 0, 0, 0.38)",
        }}
      >
        {choices.map((choice) => (
          <button
            key={choice.value}
            type="button"
            role="option"
            aria-selected={choice.value === value}
            data-reason-option={choice.value}
            onClick={() => {
              onChange?.(choice.value);
              menuRef.current?.removeAttribute("open");
            }}
            style={{
              width: "100%",
              padding: "9px 10px",
              border: 0,
              borderRadius: 6,
              background: choice.value === value
                ? "color-mix(in srgb, var(--color-accent) 18%, transparent)"
                : "transparent",
              color: "inherit",
              font: "inherit",
              lineHeight: 1.35,
              textAlign: "left",
              whiteSpace: "normal",
              overflowWrap: "anywhere",
              cursor: "pointer",
            }}
          >
            {choice.label}
          </button>
        ))}
      </div>
    </details>
  );
}
